import request from '../../../api/request';

const CURRENT_ACCOUNT = {
  SEARCH_STUDENT: `/maintainers-portal/financial-portal/current-account/students/search/`,
  FIND_STUDENT_BY_ID: (studentId: number | string) =>
    `/maintainers-portal/financial-portal/current-account/students/${studentId}`,
};

// Refactor: the search endpoint now takes tipo-ID + ID (+ optional countryId)
// instead of the legacy `{ identifier, country }` shape — aligning with the
// teacher activation maintainer.
export default function searchStudent(query: {
  identificationTypeId: string;
  identification: string;
  countryId?: string | null;
}) {
  return request<{ studentId: number; rutOrPassport: string; name: string }>(
    CURRENT_ACCOUNT.SEARCH_STUDENT,
    {
      params: {
        identificationTypeId: query.identificationTypeId,
        identification: query.identification,
        countryId: query.countryId ?? undefined,
      },
    },
  );
}

// HU #15313 — deep-link loader: fetch the same `{ studentId, rutOrPassport,
// name }` envelope returned by `searchStudent`, but keyed on studentId only.
export function findStudentById(studentId: number | string) {
  return request<{ studentId: number; rutOrPassport: string; name: string }>(
    CURRENT_ACCOUNT.FIND_STUDENT_BY_ID(studentId),
  );
}
